import React from 'react'
import moment from 'moment'

import { Paper, Grid, Typography, Divider, CircularProgress } from '@material-ui/core'

import { getSourceDescription } from '../../../utils'

export const MobileDetails = (props) => {
  const { classes, capture, additionalTerms } = props

  const reportedAt = capture ? capture.reportedAt : 'N/A'
  const receivedAt = capture ? capture.receivedAt : 'N/A'
  const applicationName = capture ? capture.applicationName ? capture.applicationName : 'N/A' : 'N/A'
  const workstationName = capture ? capture.workstationName ? capture.workstationName : 'N/A' : 'N/A'

  const renderUnit = (capture) => {
    const arr = capture.units.map((unit) => unit.unitName)
    return arr.join('/')
  }

  return (
    <>
      {capture
        ? (
          <Paper className='mt-3 w-100'>
            <Grid container direction='row' item className={`${classes.listRoot} mt-2 mb-1`}>
              <Grid item container direction='column'>

                {/* User and phrases */}
                <Grid item container direction='row' justify='center' style={{ textAlign: 'center' }}>
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>User</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>Phrases</Typography>
                  </Grid>
                </Grid>
                <Grid item container direction='row' justify='center' style={{ textAlign: 'center' }}>
                  {/* User */}
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' gutterBottom>{capture.userDisplayName || capture.username}</Typography>
                  </Grid>
                  {/* Phrase/Phrases */}
                  <Grid item xs={6} style={{ maxHeight: '6em', overflow: 'scroll' }}>
                    {capture.multiple_phrases
                      ? (
                        additionalTerms.map((term, index) => {
                          return (
                            <Typography key={`${capture.violationID} term number ${index}`}>{term.phrase}</Typography>
                          )
                        })
                      )
                      : (
                        <Typography variant='subtitle2' gutterBottom>{capture.phrase}</Typography>
                      )}
                  </Grid>
                </Grid>
                <Divider variant='middle' />

                {/* Machine Time and Source */}
                <Grid item container direction='row' justify='center' style={{ textAlign: 'center', marginTop: '.5em' }}>
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>Machine Time</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>Source</Typography>
                  </Grid>
                </Grid>
                <Grid item container direction='row' justify='center' style={{ textAlign: 'center', marginTop: '.5em' }}>
                  {/* Machine Time */}
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' gutterBottom>{moment.unix(reportedAt / 1000).format('MM/DD/YYYY')}</Typography>
                    <Typography variant='subtitle2' gutterBottom>{moment.unix(reportedAt / 1000).format('LT')}</Typography>
                  </Grid>
                  {/* Source */}
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' gutterBottom>{getSourceDescription(capture.source)}</Typography>
                  </Grid>
                </Grid>
                <Divider variant='middle' />

                {/* Console Time and Category */}
                <Grid item container direction='row' justify='center' style={{ textAlign: 'center', marginTop: '.5em' }}>
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>Console Time</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>Category</Typography>
                  </Grid>
                </Grid>
                <Grid item container direction='row' justify='center' style={{ textAlign: 'center', marginTop: '.5em' }}>
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' gutterBottom>{moment.unix(receivedAt / 1000).format('MM/DD/YYYY')}</Typography>
                    <Typography variant='subtitle2' gutterBottom>{moment.unix(receivedAt / 1000).format('LT')}</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' gutterBottom>{capture.categoryName}</Typography>
                  </Grid>
                </Grid>
                <Divider variant='middle' />

                {/* Received and IP Address */}
                <Grid item container direction='row' justify='center' style={{ textAlign: 'center', marginTop: '.5em' }}>
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>Received Time</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>IP Address</Typography>
                  </Grid>
                </Grid>
                <Grid item container direction='row' justify='center' style={{ textAlign: 'center', marginTop: '.5em' }}>
                  {/* Received At */}
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' gutterBottom>{moment.unix(receivedAt / 1000).format('MM/DD/YYYY')}</Typography>
                    <Typography variant='subtitle2' gutterBottom>{moment.unix(receivedAt / 1000).format('LT')}</Typography>
                  </Grid>
                  {/* IP Address */}
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' gutterBottom>{capture.station_ip}</Typography>
                  </Grid>
                </Grid>
                <Divider variant='middle' />

                {/* Location */}
                <Grid item container direction='row' justify='center' style={{ textAlign: 'center', marginTop: '.5em' }}>
                  <Grid item>
                    <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>Location</Typography>
                  </Grid>
                </Grid>
                <Grid item container direction='row' justify='center' style={{ textAlign: 'center', marginTop: '.5em' }}>
                  <Grid item>
                    <Typography variant='subtitle2' gutterBottom>{renderUnit(capture)}</Typography>
                  </Grid>
                </Grid>
                <Divider variant='middle' />

                {/* Application and Machine */}
                <Grid item container direction='row' justify='center' style={{ textAlign: 'center', marginTop: '.5em' }}>
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>Application</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>Machine</Typography>
                  </Grid>
                </Grid>
                <Grid item container direction='row' justify='center' style={{ textAlign: 'center', marginTop: '.5em' }}>
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' gutterBottom>{applicationName}</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant='subtitle2' gutterBottom>{workstationName}</Typography>
                  </Grid>
                </Grid>
                <Divider variant='middle' />

                {/* Violation ID */}
                <Grid item container direction='row' justify='center' style={{ textAlign: 'center', marginTop: '.5em' }}>
                  <Grid item>
                    <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>Violation ID</Typography>
                  </Grid>
                </Grid>
                <Grid item container direction='row' justify='center' style={{ textAlign: 'center', marginTop: '.5em' }}>
                  <Grid item>
                    <Typography variant='subtitle2' gutterBottom>{capture.violationID}</Typography>
                  </Grid>
                </Grid>
                <Divider variant='middle' />
              </Grid>
            </Grid>
          </Paper>
        )
        : (
          <Paper className='mt-3'>
            <Grid container direction='row' item className={`${classes.listRoot} mt-1`}>
              <Grid item container justify='center' alignContent='center' className='m-4'>
                <CircularProgress color='primary' classes={{ colorPrimary: classes.loadingColor }} />
              </Grid>
            </Grid>
          </Paper>
        )}
    </>
  )
}
